module.exports = __webpack_public_path__ + "media/images/logo-f81d9fe2bdd8d01faca23a8915c94da8.png";